import { render, staticRenderFns } from "./selectProductTable.vue?vue&type=template&id=4fcf4fa2&scoped=true"
import script from "./selectProductTable.vue?vue&type=script&lang=js"
export * from "./selectProductTable.vue?vue&type=script&lang=js"
import style0 from "./selectProductTable.vue?vue&type=style&index=0&id=4fcf4fa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcf4fa2",
  null
  
)

export default component.exports